import {Recaptcha3Service} from '@shared/services/Recaptcha3Service'
import {useEffect} from 'react'
import {AppConfig} from '../AppConfig'

// Загрузить и настроить скрипт Recaptcha.
export function useRecaptcha(): void {
    useEffect(() => {
        Recaptcha3Service.init(AppConfig.recaptchaSiteKey)
        return () => {
            // Сбросить Recaptcha и спрятать её иконку.
            Recaptcha3Service.hide()
        }
    }, [])
}
